import { useEffect } from 'react';

export default function useOutsideClick(ref, cb) {
  function handleClickOutside(event) {
    if (event && ref.current && !ref.current.contains(event.target)) {
      cb(event);
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return handleClickOutside();
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useOutsideClick.js